/**
 * Authenticated fetch wrapper
 *
 * Wraps the native fetch API to automatically include the Authorization header
 * from localStorage. Use this instead of raw fetch() for authenticated requests.
 */

export async function authenticatedFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  const token = localStorage.getItem('access_token');

  const headers = new Headers(init?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(input, {
    ...init,
    headers,
  });
}
